import { Injectable } from '@angular/core';
import { country } from '../common/enums/language';
import { LanguageService } from '../common/services/language.service';

@Injectable({
  providedIn: 'root',
})
export class MetaDataServiceService {
  countryText: string = 'Malaysia';
  constructor( private languageService: LanguageService) {
    if(this.languageService.getCountry() === country.id.country) {
      this.countryText = 'Indonesia'
    }
  }
  private metadata: {
    [key: string]: { title: string; description: string; keywords: string };
  } = {
    home: {
      title:
        'Digitise your restaurants with EasyEatand and increase your earnings',
      description:
        `EasyEat is the most advanced cloud-based POS system in ${this.countryText}. Digitise your restaurants in ${this.countryText} through EasyEat and generate 30% more revenue and operate at 15% less cost!`,
      keywords:
        `Partner app Easyeat, Partner EasyEat, EasyEat partner, EasyEat ${this.countryText}`,
    },
    login: {
      title: 'Login Page',
      description: 'Discover the services we offer.',
      keywords:
        `Partner app Easyeat, Partner EasyEat, EasyEat partner, EasyEat ${this.countryText}`,
    },
    // Add more pages here
  };

  getMetadata(page: string): {
    title: string;
    description: string;
    keywords: string;
  } {
    return this.metadata[page] || this.defaultMetadata();
  }

  private defaultMetadata(): {
    title: string;
    description: string;
    keywords: string;
  } {
    return {
      title:
        'Digitise your restaurants with EasyEat and increase your earnings',
      description:
        `EasyEat is the most advanced cloud-based POS system in ${this.countryText}. Digitise your restaurants in ${this.countryText} through EasyEat and generate 30% more revenue and operate at 15% less cost!`,
      keywords:
        `Partner app Easyeat, Partner EasyEat, EasyEat partner, EasyEat ${this.countryText}`,
    }
  }
}
